var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"buttonOriginal",attrs:{"id":"show-modal","title":_vm.trans.get('common.export_ppt_action')},on:{"click":_vm.afficheModal}},[_c('i',{staticClass:"fa fa-file-powerpoint-o"})]),_vm._v(" "),(_vm.showModal)?_c('exportModal',{attrs:{"routesubmit":this.routesubmit},on:{"close":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }